import { FunctionComponent, useCallback, type JSX } from 'react';

import { useFieldId } from '@payaca/hooks/useFieldId';
import FieldLabel from '../fieldLabel/FieldLabel';
import Switch from '../switch/Switch';

import './SwitchField.sass';

type Props = {
  name: string;
  value?: boolean;
  label?: string | JSX.Element;
  ariaLabel?: string;
  description?: string | JSX.Element;
  isDisabled?: boolean;
  isRequired?: boolean;
  onChange?: (value: { [key: string]: boolean }) => void;
  onTouch?: (fieldName: string) => void;
};

const SwitchField: FunctionComponent<Props> = ({
  name,
  value = false,
  label,
  ariaLabel,
  description,
  isDisabled,
  isRequired,
  onChange,
  onTouch,
}: Props): JSX.Element => {
  const onSwitchChange = useCallback(() => {
    // oxlint-disable-next-line eslint/no-unused-expressions -- FIXME: pre-existing error: Expected expression to be used
    onChange && onChange({ [name]: !value });
    // oxlint-disable-next-line eslint/no-unused-expressions -- FIXME: pre-existing error: Expected expression to be used
    onTouch && onTouch(name);
  }, [onChange, onTouch, value, name]);

  const id = useFieldId(name);

  return (
    <div className="switch-field">
      <div className="switch-wrapper">
        <Switch
          isChecked={value}
          isDisabled={isDisabled}
          onChange={onSwitchChange}
          id={id}
          ariaLabel={ariaLabel}
        />
      </div>
      <FieldLabel
        label={label}
        id={id}
        description={description}
        isRequired={isRequired}
      />
    </div>
  );
};

export default SwitchField;
